import type { ReactNode } from "react";
import { Eyebrow } from "../../../components/design";

export type FaqItem = { q: string; a: ReactNode };

type FaqProps = {
  items: FaqItem[];
};

// Accessible <details>/<summary> FAQ. Mirrors the FAQPage JSON-LD injected at
// prerender time so the questions and answers line up.
export default function FaqSection({ items }: FaqProps) {
  return (
    <section style={{ padding: "24px 0 8px" }}>
      <Eyebrow>Häufige Fragen</Eyebrow>
      <h2
        style={{
          fontFamily: "var(--f-display)",
          fontWeight: 400,
          fontSize: 26,
          lineHeight: 1.12,
          letterSpacing: "-0.012em",
          margin: "0 0 14px",
          color: "var(--ink)",
        }}
      >
        Fragen, die häufig kommen
      </h2>

      <div>
        {items.map((it, i) => (
          <details
            key={i}
            style={{
              borderTop: "1px solid rgba(43,26,15,0.10)",
              padding: "14px 0",
            }}
          >
            <summary
              style={{
                cursor: "pointer",
                fontFamily: "var(--f-display)",
                fontSize: 18,
                fontWeight: 500,
                color: "var(--ink)",
                listStyle: "none",
              }}
            >
              {it.q}
            </summary>
            <div
              style={{
                marginTop: 8,
                fontFamily: "var(--f-body)",
                fontSize: 16,
                lineHeight: 1.55,
                color: "var(--ink-soft)",
              }}
            >
              {it.a}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
